@if (_currentData.bannerJson!=undefined) {
  <div>
    @if (_currentData.bannerJson.component == undefined) {
      <app-resource-banner [bannerJson]="_currentData.bannerJson"
      (footerLinksClick)="threeDotClick($event)"></app-resource-banner>
    }
  </div>
}
<div class="main-container-body">
  @if (ShowComponent) {
    @if (route.snapshot.queryParams.returnUrl && !utilService.isMobile()) {
      <div class="page-title-container d-flex">
        <div class="page-title flex-grow-1">
          <div class="mb-0">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2">
                <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                  <img src="assets/images/grid-back.png" />
                </a>
              </div>
              @if (_currentData!=undefined && _currentData.backTitle!=undefined) {
                <div>
                  {{_currentData.backTitle}}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    <div class="pb-5 mb-5">
      <!-- [focusInvalidInput]="form" -->
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="acknowledge-outsource">
          @if (_currentData.json !=undefined && _currentData.json) {
            <dhs-editable-grid formControlName="gridData"
              [validIn]='validIn' [resource]="_currentData.json" (listen_changes)="listen_changes($event)">
            </dhs-editable-grid>
          }
        </div>
        <div class="row floating-button-container">
          @if (_currentData.buttons!=undefined) {
            <div [ngClass]="(buttonshow && _currentData.config && _currentData.config.floating_button)  ? 'floating-button': '' "  class="col-lg-12 makeCenter mt-3 margin-bottom-30-mb">
              @for (btn of btns['avilabelBpmnBtns']; track btn) {
                <button type="button"
                  [ngClass]="btn.class_name?btn.class_name:'btn mr-1 form-btn btn-save'"
                  (click)="onSubmit(btn);">{{(btn.label != undefined?btn.label:'Submit') | translate |
                  async}}
                  <i class="ml-3" [ngClass]="btn.btn_icon !=undefined?btn.btn_icon:'fa fa-floppy-o text-white' " aria-hidden="true"></i>
                </button>
              }
            </div>
          }
        </div>
      </form>
    </div>
  }
</div>
